import React from "react";

/**
 * Shared pill/chip/tab. `active` toggles brand-fill vs white+warm-border.
 * Radius 100px, ≥44px tall when interactive (onClick present).
 */
export default function Pill({ active = false, className = "", children, onClick, ...rest }) {
  const interactive = typeof onClick === "function";
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      className={
        "inline-flex items-center gap-1.5 rounded-full px-4 font-body font-extrabold text-[13px] " +
        "transition select-none " +
        (interactive ? "min-h-[44px] cursor-pointer" : "py-2 pointer-events-none") +
        " " +
        (active
          ? "bg-brand text-white shadow-primary"
          : "bg-white text-ink border border-cardline hover:border-brand") +
        " " +
        className
      }
      {...rest}
    >
      {children}
    </button>
  );
}
